<template>
    <div class="ccpay-adduser">
        <div class="ccpay-adduse-header">
                <span @click="back"> 退後</span>
                <span v-show="type=='1'">增加二维码帳戶</span>
                <span v-show="type=='2'">增加銀行卡帳戶</span>
                <span v-show="type=='3'">更改二维码帳戶</span>
                <span v-show="type=='4'">更改銀行卡帳戶</span>
                <span></span>
        </div>
        <div>
            <ul>
                <!-- <clicksss></clicksss> -->
                <li v-show="type=='1'||type=='3'">
                <p class="sup-tec" style="font-size: 16px;">收款二维码</p>
                    <CloudflareR2Upload
                        :folder-prefix="'pay_account/ali/'"
                        accept-types="image/*"
                        :max-file-size="1024"
                        button-text="上传收款码"
                        @upload-success="handleUploadSuccess"
                        @upload-error="handleUploadError"
                        @upload-remove="handleUploadRemove"
                    />
                </li>
                <li>
                  <mt-field class="phoneNum phoneNumTull-lv"  
                   placeholder="姓名" 
                    v-model="name"
                    style="border-bottom: 1px solid #eee;" 
                    ></mt-field>
                </li>
                <li v-show="type=='1'||type=='3'">
                   <mt-field class="phoneNum phoneNumTull-lv"
                   
                      v-model="phoneNum"
                      placeholder="二维码帳號" 
                    ></mt-field>
                </li>
                <li v-show="type=='2'||type=='4'">
                   <mt-field class="phoneNum phoneNumTull-lv"
                      v-model="phoneNum"
                      placeholder="銀行卡帳號" 
                    ></mt-field>
                </li>
                <li v-show="type=='2'||type=='4'">
                   <mt-field class="phoneNum phoneNumTull-lv"
                      v-model="Bankname"
                      placeholder="开户行名稱" 
                    ></mt-field>
                </li>
                <li v-show="type=='2'||type=='4'">
                   <mt-field class="phoneNum phoneNumTull-lv"
                      v-model="Bankaddress"
                      placeholder="开户行地址" 
                    ></mt-field>
                </li>
                <li v-show="type=='3'||type=='4'">
                    <mt-button class="mt-40" size="large" type="primary" 
                        @click="remove()">刪除</mt-button>
                </li>
                <li>
                    <mt-button class="mt-40" size="large" type="primary" 
                        @click="adduser()">{{type=="1"||type=="2"?'增加':'更改'}}</mt-button>
                </li>
                <!-- <img :src="src"/> -->
                <!-- <li>1</li> -->
            </ul>
        </div>
    </div>
</template>

<script>
import { Indicator } from 'mint-ui';
import clicksss from '../../component/ccpay/Dropzone.vue'
import moment from "moment"
import CloudflareR2Upload from '../CloudflareR2Upload.vue'
export default {
    components:{
        clicksss,
        CloudflareR2Upload
    },
    data(){
        return{
            type:'',//增加类型
            uploadedImageUrl:'',//上传的图片URL
            name:'',//姓名
            phoneNum:'',//帳號
            Bankname:'',//銀行
            Bankaddress:'',//銀行地址
            fatherdata:'',
            id:'',
        }
    },
    mounted(){
        this.type = this.$route.query.type
        if(this.$route.query.item){
             this.fatherdata = JSON.parse(this.$route.query.item)
             this.id = this.fatherdata.id
             if(this.type=="3"){
                 this.uploadedImageUrl = this.fatherdata.qr_link
                this.name = this.fatherdata.account_name
                this.phoneNum = this.fatherdata.user_id
             }else if(this.type=="4"){
                this.name = this.fatherdata.account_name
                this.phoneNum = this.fatherdata.platform_account_no
                this.Bankname = this.fatherdata.bank_name
                this.Bankaddress = this.fatherdata.bank_branch_name
             }
        }
        // console.log(JSON.parse(this.$route.query.item))
        
    },
    methods:{
        moment,
        back(){
            this.$router.go(-1)
        },
        // CloudflareR2Upload 组件事件处理
        handleUploadSuccess(fileUrl, fileInfo) {
            console.log('上传成功:', fileUrl);
            this.uploadedImageUrl = fileUrl;
            this.$Toast('图片上传成功');
        },
        handleUploadError(errorInfo) {
            console.error('上传失败:', errorInfo);
            this.$Toast('图片上传失败，请重试');
        },
        handleUploadRemove(removeInfo) {
            console.log('删除图片:', removeInfo);
            this.uploadedImageUrl = '';
        },
        adduser(){
            if(this.type==1||this.type==2){
                if(this.type==1){
                    this.addpay()
                 }else{
                    this.addcard()
                }
           }else{
               if(this.type==3){
                    this.emitpay()
                 }else{
                    this.emitcard()
                }
           }
        },//增加支付寶
        twoaddpay(){
                
                this.$axios.post('/v1/traders/payaccount/alipay/create',{
                "user_id": this.phoneNum,
                "qr_link": this.uploadedImageUrl,
                "account_name":  this.name
                }).then(res=>{
                    Indicator.close();
                    if(res.data){
                        this.$router.go(-1)
                        this.$Toast(res.msg)
                    }else{
                        this.$Toast(res.msg)
                    }
                })
        },
        addpay(){
            if(this.name==''){
                 this.$Toast('请输入姓名')
                 return
            }
            if(this.phoneNum==''){
                 this.$Toast('请输入二维码帳號')
                 return
            }
            if(this.uploadedImageUrl==''){
                 this.$Toast('请上传收款二维码')
                 return
            }
             this.twoaddpay()
           

        },//增加銀行卡
        addcard(){
            if(this.name==''){
                this.$Toast('请输入姓名')
                 return
            }
            if(this.phoneNum==''){
                this.$Toast('请输入銀行卡卡号')
                 return
            }
            if(this.phoneNum==''){
                this.$Toast('请输入銀行卡卡号')
                 return
            }
            if(this.Bankname==''){
                this.$Toast('请输入开户行名稱')
                 return
            }
            if(this.Bankaddress==''){
                this.$Toast('请输入开户行地址')
                 return
            }
            
                Indicator.open();
            this.$axios.post('/v1/traders/payaccount/bank/create',{
                   "platform_account_no": this.phoneNum,
                    "account_name": this.name,
                    "bank_name":this.Bankname,
                    "bank_branch_name": this.Bankaddress
                }).then(res=>{
                     Indicator.close();
                    if(res.data){
                        this.$router.go(-1)
                        this.$Toast(res.msg)
                    }else{
                        this.$Toast(res.msg)
                    }
                })
              
        },
        twoemitpay(){
            Indicator.open();
            this.$axios.post('/v1/traders/payaccount/alipay/update',{
                "user_id": this.phoneNum,
                "qr_link": this.uploadedImageUrl,
                "account_name": this.name,
                "id":this.id
            }).then(res=>{
                Indicator.close();
                if(res.code==0){
                     this.$router.go(-1)
                     this.$Toast('更改成功')
                }else{
                    this.$Toast(res.msg)
                }
            })
          
        },
        //更改支付寶
        emitpay(){
            if(this.name==''){
                this.$Toast('请输入姓名')
                return
            }
            if(this.phoneNum==''){
                this.$Toast('请输入二维码帳號')
                return
            }
            if(this.uploadedImageUrl==''){
                this.$Toast('请上传二维码收款二维码')
                return
            }
           
            this.$MessageBox.confirm('',{
                title:'提示',
                message:`您确定要执行该操作 `,
                confirmButtonText:'确定',
                cancelButtonText:'取消'
            }).then(action => {
                this.twoemitpay()
            })
        },
        //更改銀行卡 
        emitcard(){
            if(this.name==''){
                this.$Toast('请输入姓名')
                 return
            }
            if(this.phoneNum==''){
                this.$Toast('请输入銀行卡卡号')
                 return
            }
            if(this.phoneNum==''){
                this.$Toast('请输入銀行卡卡号')
                 return
            }
            if(this.Bankname==''){
                this.$Toast('请输入开户行名稱')
                 return
            }
            if(this.Bankaddress==''){
                this.$Toast('请输入开户行地址')
                 return
            }
             
            this.$MessageBox.confirm('',{
                title:'提示',
                message:`您确定要执行该操作 `,
                confirmButtonText:'确定',
                cancelButtonText:'取消'
            }).then(action => {
                 Indicator.open();
            this.$axios.post('/v1/traders/payaccount/bank/update',{
                "platform_account_no": this.phoneNum,
                "account_name": this.name,
                 "bank_name":this.Bankname,
                 "bank_branch_name": this.Bankaddress,
                 "id":this.id
            }).then(res=>{
                 Indicator.close();
                 if(res.code==0){
                     this.$router.go(-1)
                     this.$Toast('更改成功')
                }else{
                    this.$Toast(res.msg)
                }
            })
            }).catch(error =>{
                
            })

        },
        remove(){
             this.$MessageBox.confirm('',{
                title:'提示',
                message:`您确定要执行该操作 `,
                confirmButtonText:'确定',
                cancelButtonText:'取消'
            }).then(action => {
                this.removeuser()
               
            }).catch(error =>{
                
            })
        },
        removeuser(){
            Indicator.open();
            this.$axios.post('/v1/traders/payaccount/remove',{
                 "user_id": this.phoneNum,
                 "qr_link": this.uploadedImageUrl,
                 "account_name": "赵小帅",
                "id": this.id
            }).then(res=>{
                  Indicator.close();
                if(res.code==0){
                     this.$router.go(-1)
                     this.$Toast('刪除成功')
                }else{
                    this.$Toast(res.msg)
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .ccpay-adduser{
          background: white;
          height: 100%;;
        .ccpay-adduse-header{
            background: white;
            display: flex;
            justify-content: space-between;
            padding: 1rem;
        }
    }
    .sup-tec{
             color: #888;
            text-align: center;
            line-height: 3rem;
        }
    .ccpay-resadd-img{
        margin-bottom: 1rem;
        display: flex;
        justify-content: center;
        button{
             background: #ccc;
            padding: 6px;
            outline: none;
            border: none;
            color: white;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Receivables/adddetail.vue